import { render, staticRenderFns } from "./IntegrationsTable.vue?vue&type=template&id=7dbf3d5e&scoped=true&"
import script from "./IntegrationsTable.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationsTable.vue?vue&type=style&index=0&id=7dbf3d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf3d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
